export const LAYOUT_PAGES = [
  '/isg/',
  '/admin/',
  '/firm/'
  // Diğer layout sayfaları buraya eklenebilir
] as const;

export const isLayoutPage = (pathname: string): boolean => {
  return LAYOUT_PAGES.some(path => pathname.startsWith(path));
};